import * as Constants from '../constants/settings';

const initialState = {
  activeOcrModerationService: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_OCR_MODERATION_SERVICE_SUCCESS:
      return {
        ...state,
        activeOcrModerationService: action.payload,
      };
    default:
      return state;
  }
};
